import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlayCircle,
  faTimesCircle,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { baseURL } from "../../../api/dataFetcher";

export default function WatchedVideoCard({
  iconHref = "#",
  imgHref = "#",
  imgSrc,
  imgAlt = "",
  time = "-:-",
  videoTitle = "#",
  videoTitleHref,
  views,
  timeAgo,
  videoCategory,
  verified = null,
  progressTime = "-:-",
  progress = "0",
  videoId,
}) {
  return (
    <>
      <Col xl={3} sm={6} className="mb-3">
        <div className="video-card fullHeight history-video">
          <div className="video-card-image">
            <a className="play-icon" href={`/video-page/${videoId}`}>
              <FontAwesomeIcon icon={faPlayCircle} />
            </a>
            <a href={imgHref}>
              <div
                style={{ width: "100%", height: "150px", objectFit: "cover" }}
              >
                <img
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  className="img-fluid"
                  src={baseURL + imgSrc}
                  alt={imgAlt}
                />
              </div>
            </a>
            {/* <div className="time">{time}</div> */}
          </div>
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: progress + "%" }}
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {progressTime}
            </div>
          </div>
          <div className="video-card-body">
            <div className="video-title">
              <a href={videoTitleHref}>{videoTitle}</a>
            </div>
            <div
              className={
                verified
                  ? "video-page text-success-custom"
                  : "video-page text-danger-custom"
              }
            >
              {videoCategory}
            </div>
            <div className="video-view">
              {views} بازدید &nbsp;
              <FontAwesomeIcon icon={faCalendarAlt} /> {timeAgo}
            </div>
          </div>
        </div>
      </Col>
    </>
  );
}
